import { BarChart } from "../../../FuturebilityCockpit/components/BarChart";
import { MenuButton } from "../../../FuturebilityCockpit/components/MenuButton";
import { PopoverDropdown } from "../../../FuturebilityCockpit/components/PopoverDropdown";
import { SolutionJourney } from "../../../FuturebilityCockpit/components/SolutionJourney";
import { SolutionJourneyTabs } from "../../../FuturebilityCockpit/components/SolutionJourneyTabs";
import { Cube } from "../../../FuturebilityCockpit/components/Сube";
import { Button } from "../../components";
import { AreaSlider } from "../../components/area-slider";
import { BottomBar } from "../../components/bottom-bar";
import { Footer } from "../../components/footer";
import { HeaderAnalytics } from "../../components/header-analytics/header-analytics";
import { HeaderReflection } from "../../components/header-reflection";
import { HeaderSolution } from "../../components/header-solution";
import { JourneyMap } from "../../components/journey-map";
import { PersonalityMatrix } from "../../components/personality-matrix";
import { PersonalityMatrixAdvanced } from "../../components/personality-matrix-advanced";
import {
  QuadrantAxis,
  QuadrantScatter,
  QuadrantTotal,
} from "../../components/quadrant";
import { SplitSlider } from "../../components/split-slider";
import { WordCloud } from "../../components/word-cloud";

const words = [
  { label: "allen unbeka", value: 1.0 },
  { label: "selektiv bekann", value: 2.1 },
  { label: "wenig erläutert", value: 2.1 },
  { label: "unklare Prioritäten", value: 3.4 },
  { label: "teilweise bekanınicht", value: 4.7 },
  { label: "verankert", value: 4.9 },
  { label: "gut verständlich", value: 5.2 },
  { label: "breit bekannt", value: 6.0 },
  { label: "klarer Fokus", value: 7.0 },
  { label: "handlungsleitend", value: 8.0 },
  { label: "überall konsistent", value: 9.0 },
  { label: "allen unbeka2", value: 1.0 },
  { label: "selektiv bekann3", value: 2.1 },
  { label: "wenig erläutert4", value: 2.1 },
  { label: "unklare Prioritäten5", value: 3.4 },
  { label: "teilweise bekanınicht6", value: 4.7 },
  { label: "verankert7", value: 4.9 },
  { label: "gut verständlich8", value: 5.2 },
  { label: "breit bekannt9", value: 6.0 },
  { label: "klarer Fokus10", value: 7.0 },
  { label: "handlungsleitend11", value: 8.0 },
  { label: "überall konsistent12", value: 9.0 },
];

const points = [
  { x: 1, y: 1 },
  { x: 0.55, y: 0.65 },
  { x: 0.35, y: 0.45 },
  { x: 0.75, y: 0.35 },
  { x: 0.85, y: 0.25 },
  { x: 0.25, y: 0.85 },
  { x: 0.95, y: 0.15 },
  { x: 0.4, y: 0.7 },
  { x: 0.6, y: 0.6 },
  { x: 0.7, y: 0.4 },
  { x: 0.8, y: 0.3 },
  { x: 0.5, y: 0.8 },
  { x: 0.9, y: 0.2 },
  { x: 0.3, y: 0.9 },
  { x: 0.65, y: 0.55 },
  { x: 0.6, y: 0.53 },
  { x: 0.61, y: 0.54 },
  { x: 0.63, y: 0.55 },
];

const Section = ({ title, children }) => (
  <section style={{ padding: "40px 15px" }}>
    <h2
      style={{
        color: "#fff",
        marginBottom: 18,
      }}
    >
      {title}
    </h2>
    {children}
  </section>
);

export const Demo = () => {
  return (
    <section
      style={{
        background: "var(--fl-color-background)",
        minHeight: "100vh",
        padding: "40px 15px",
      }}
    >
      <Section title="Solution Journey">
        <SolutionJourney
          journey1={{
            title: "Concept",
            items: ["Purpose", "Reason Why", "Vision"],
          }}
          journey2={{
            title: "Commitment",
            items: ["Choices", "Roles", "Test Set"],
          }}
          journey3={{
            title: "Control",
            items: ["Quick Wins", "KPIs", "Leadership"],
          }}
        />
      </Section>
      <Section title="Solution Journey Tabs">
        <SolutionJourneyTabs
          onJourneyClicked={(tabId, subItemId) =>
            console.log("Journey clicked - Tab:", tabId, "SubItem:", subItemId)
          }
          journey1={{
            id: "concept",
            title: "Concept",
            items: [
              { id: "concept-1", label: "Purpose" },
              { id: "concept-2", label: "Reason Why" },
              { id: "concept-3", label: "Vision" },
            ],
          }}
          journey2={{
            id: "commitment",
            title: "Commitment",
            items: [
              { id: "commitment-1", label: "Choices" },
              { id: "commitment-2", label: "Roles" },
              { id: "commitment-3", label: "Test Set" },
            ],
          }}
          journey3={{
            id: "control",
            title: "Control",
            items: [
              { id: "control-1", label: "Quick Wins" },
              { id: "control-2", label: "KPIs" },
              { id: "control-3", label: "Leadership" },
            ],
          }}
        />
      </Section>
      <Section title="Journey Map">
        <JourneyMap
          onPhaseItemClick={id => console.log("Navigate to phase item:", id)}
          progress={33}
          phases={[
            {
              id: "1",
              title: "Concept",
              color: "var(--fl-color-primary)",
              items: [
                {
                  id: "11",
                  label: "Purpose",
                  completed: true,
                },
                {
                  id: "12",
                  label: "Reason Why",
                  completed: false,
                },
                {
                  id: "13",
                  label: "Vision",
                  completed: false,
                },
              ],
            },
            {
              id: "2",
              title: "Commitment",
              color: "#557DE1",
              items: [
                {
                  id: "21",
                  label: "Choices",
                  completed: true,
                },
                {
                  id: "22",
                  label: "Roles",
                  completed: false,
                },
                {
                  id: "23",
                  label: "Test Set",
                  completed: true,
                },
              ],
            },
            {
              id: "3",
              title: "Control",
              color: "var(--fl-color-secondary)",
              items: [
                {
                  id: "31",
                  label: "Quick Wins",
                  completed: false,
                },
                {
                  id: "32",
                  label: "KPIs",
                  completed: false,
                },
                {
                  id: "33",
                  label: "Leadership",
                  completed: true,
                },
              ],
            },
          ]}
        />
      </Section>
      <Section title="Advanced Personality Matrix">
        <PersonalityMatrixAdvanced
          isClustered={true}
          labels={{
            left: "Gemeinschaft",
            leftSub: "Gemeinschaftsorientiert – ausgleichsorientiert",
            right: "Erfolg",
            rightSub: "Erfolgssinn –erfolgsorientiert – ehrgeizig",
            top: "Chancen",
            topSub: "Chancenorientiert – risikobereit",
            bottom: "Sicherheit",
            bottomSub: "Sicherheitsorientiert – risikovermeidend",
            topLeft: "Partnerschaft",
            topRight: "Wettbewerb",
            bottomLeft: "Kontinuität",
            bottomRight: "Leistung",
            grid1: "Vermittler",
            grid2: "Berater",
            grid3: "Innovator",
            grid4: "Kontrolleur",
            grid5: "Direktor",
            grid6: "Motivator",
            grid7: "Bremser",
            grid8: "Kritiker",
            grid9: "Treiber",
          }}
          content={{
            leftSub: "Left Sub Content",
            rightSub: "Right Sub Content",
            topSub: "Top Sub Content",
            bottomSub: "Bottom Sub Content",
            topLeft: "Top Left Content",
            topRight: "Top Right Content",
            bottomLeft: "Bottom Left Content",
            bottomRight: "Bottom Right Content",
            grid1: "Grid 1 Content",
            grid2: "Grid 2 Content",
            grid3: "Grid 3 Content",
            grid4: "Grid 4 Content",
            grid5: "Grid 5 Content",
            grid6: "Grid 6 Content",
            grid7: "Grid 7 Content",
            grid8: "Grid 8 Content",
            grid9: "Grid 9 Content",
          }}
          points={points}
        />
      </Section>
      <Section title="Advanced Personality Matrix">
        <PersonalityMatrixAdvanced
          labels={{
            left: "Gemeinschaft",
            leftSub: "Gemeinschaftsorientiert – ausgleichsorientiert",
            right: "Erfolg",
            rightSub: "Erfolgssinn –erfolgsorientiert – ehrgeizig",
            top: "Chancen",
            topSub: "Chancenorientiert – risikobereit",
            bottom: "Sicherheit",
            bottomSub: "Sicherheitsorientiert – risikovermeidend",
            topLeft: "A",
            topRight: "B",
            bottomLeft: "C",
            bottomRight: "D",
            grid1: "Vermittler",
            grid2: "Berater",
            grid3: "Innovator",
            grid4: "Kontrolleur",
            grid5: "Direktor",
            grid6: "Motivator",
            grid7: "Bremser",
            grid8: "Kritiker",
            grid9: "Treiber",
          }}
          content={{
            leftSub: "Left Sub Content",
            rightSub: "Right Sub Content",
            topSub: "Top Sub Content",
            bottomSub: "Bottom Sub Content",
            topLeft: "Top Left Content",
            topRight: "Top Right Content",
            bottomLeft: "Bottom Left Content",
            bottomRight: "Bottom Right Content",
            grid1: "Grid 1 Content",
            grid2: "Grid 2 Content",
            grid3: "Grid 3 Content",
            grid4: "Grid 4 Content",
            grid5: "Grid 5 Content",
            grid6: "Grid 6 Content",
            grid7: "Grid 7 Content",
            grid8: "Grid 8 Content",
            grid9: "Grid 9 Content",
          }}
          points={points}
        />
      </Section>
      <Section title="Personality Matrix">
        <PersonalityMatrix
          activeGridIndex={2}
          gridLabels={[
            "Vermittler",
            "Berater",
            "Innovator",
            "Kontrolleur",
            "Direktor",
            "Motivator",
            "Bremser",
            "Kritiker",
            "Treiber",
          ]}
          mainLabels={{
            left: "Gemeinschaft",
            right: "Erfolg",
            top: "Chancen",
            bottom: "Sicherheit",
          }}
          points={[{ x: 1, y: 1 }]}
        />
      </Section>
      <Section title="Items">
        <MenuButton text="Items" />
      </Section>
      <Section title="Items">
        <MenuButton text="Items" />
      </Section>
      <Section title="BarChart">
        <BarChart
          bars={[
            { value: 15, label: "Weak Rejection" },
            { value: 10, label: "Weak Consent" },
            { value: 50, label: "Strong Consent" },
            { value: 25, label: "Strong Rejection" },
          ]}
        />
      </Section>
      <Section title="Scatter Quadrant Chart">
        <QuadrantScatter
          yTopTitle="dynamisch"
          yCenterTitle="Dynamik"
          yBottomTitle="statisch"
          xLeftTitle="alter Markt inkrementell"
          xCenterTitle="Innovationsgrad"
          xRightTitle="neuer Markt disruptiv"
          quadrantTitles={["Title 1", "Title 2", "Title 3", "Title 4"]}
          quadrantSidePanelTitles={[
            "Type 4 panel title",
            "Type 2 panel title",
            "Type 1 panel title",
            "Type 3 panel title",
          ]}
          quadrantSidePanelTexts={[
            "Type 4 panel description",
            "Type 2 panel description",
            "Type 1 panel description",
            "Type 3 panel description",
          ]}
          points={points}
          width={480}
          height={400}
        />
      </Section>
      <Section title="Quadrant Total">
        <QuadrantTotal
          yTopTitle="High"
          yCenterTitle="Quality"
          yBottomTitle="Low"
          xLeftTitle="Low"
          xCenterTitle="Importance"
          xRightTitle="High"
          quadrantSidePanelTitles={[
            "Type 4 panel title",
            "Type 2 panel title",
            "Type 1 panel title",
            "Type 3 panel title",
          ]}
          quadrantSidePanelTexts={[
            "Type 4 panel description",
            "Type 2 panel description",
            "Type 1 panel description",
            "Type 3 panel description",
          ]}
          points={[
            { x: 45, y: 75 },
            { x: 55, y: 65 },
            { x: 35, y: 45 },
            { x: 75, y: 35 },
            { x: 85, y: 25 },
            { x: 25, y: 85 },
            { x: 95, y: 15 },
            { x: 40, y: 70 },
            { x: 60, y: 60 },
            { x: 70, y: 40 },
            { x: 80, y: 30 },
            { x: 50, y: 80 },
            { x: 90, y: 20 },
            { x: 30, y: 90 },
            { x: 65, y: 55 },
            { x: 60, y: 53 },
            { x: 61, y: 54 },
            { x: 63, y: 55 },
          ]}
          width={480}
          height={400}
        />
      </Section>
      <Section title="Quadrant Axis">
        <QuadrantAxis
          points={points}
          xTitle="X Axis"
          yTitle="Y Axis"
          bgColor="var(--fl-color-background)"
        />
      </Section>
      <Section title="Cube">
        <Cube greyOutOtherSidesOnHover values={{ 1: 25, 2: 75, 3: 100 }} />
        <Cube
          greyOutOtherSidesOnHover
          mode="collapsed"
          values={{ 1: 25, 2: 75, 3: 60, 4: 50, 5: 80, 6: 90 }}
        />
      </Section>
      <Section title="Word Cloud">
        <div style={{ height: 500 }}>
          <WordCloud
            initialWords={words}
            words={words}
            onWordsChange={() => {}}
            maxSelectedWords={3}
          />
        </div>
      </Section>
      <Section title="Area Slider">
        <AreaSlider
          xLabel="Quality >"
          yLabel="Importance >"
          onValueChange={console.log}
        />
      </Section>
      <Section title="Split Slider">
        <div
          style={{
            display: "flex",
            gap: "32px",
            justifyContent: "center",
          }}
        >
          <SplitSlider />
          <SplitSlider mode="split" />
        </div>
      </Section>
      <Section title="Header HeaderModule3">
        <HeaderSolution
          topLabels={["Top Label 1", "Reality CheckChancen & Grenzen"]}
          countdownTime={1800} // 30 minutes
          sidePanelContent={"<div>Side Panel Content</div>"}
        />
      </Section>
      <Section title="Header HeaderModule2">
        <HeaderReflection
          countdownTime={1800} // 30 minutes
          totalProgress={50}
          topicProgress={25}
          currentQuestion={3}
          totalQuestions={6}
          topicName={"Perfomanz und Steuerung"}
        />
      </Section>
      <Section title="Header isMarket">
        <HeaderAnalytics
          isMarket={true}
          totalProgress={50}
          topicProgress={25}
          currentQuestion={3}
          totalQuestions={6}
          categoryName={"Market"}
        />
      </Section>
      <Section title="Header/Footer">
        <HeaderAnalytics
          totalProgress={50}
          topicProgress={25}
          currentQuestion={3}
          totalQuestions={6}
          categoryName={"Führung"}
        />
        <div style={{ color: "#fff" }}>Some content</div>
        <Footer
          onPreviousClick={() => {}}
          onMicrophoneClick={() => {}}
          onNextClick={() => {}}
          isNextDisabled={true}
        />
      </Section>
      <Section title="Button">
        <Button>Weiter</Button>
      </Section>
      <Section title="BottomBar">
        <BottomBar />
      </Section>
      <Section title="PopoverDropdown">
        <PopoverDropdown
          title="Select an option"
          items={[
            { id: 1, label: "Option 1", value: "option1" },
            { id: 2, label: "Option 2", value: "option2" },
            { id: 3, label: "Option 3", value: "option3" },
          ]}
          onSelect={console.log}
        />
      </Section>
    </section>
  );
};
